import React, {Component} from 'react';
import DateRangeFilterWithSubmit from '../components/DateRangeFilterWithSubmit';
import VIPSignupsReport from '../components/VIPSignupsReport';
import ReportHeaderState from '../components/ReportHeaderState';
import NoAccess from '../noAccess';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {hasSectionAccess, isSysopOrSysadmin} from '../shared/authFunctions';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/card-membership';

export const fuseVIPSignUpsReportsIcon = Icon;

/**
 * VIP Signups Reports class for displaying total signups by Location
 *
 */
export class VIPSignupsReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            allowFetch: false,
            dataState: 'waiting',
            selectedEndDate: null,
            selectedOffset: offsetDefault,
            selectedStartDate: null,
            system: system
        };
    }

    /**
     * Handle event props from DateRangeFilterWithSubmit
     *
     * @param type
     * @param value
     */
    handleDateRangeFilterSelect = (type, value) => {
        switch (type) {
            case 'start_date':
                // Set Start Date selection for reports summary component
                this.setState({allowFetch: false, selectedStartDate: value});
                break;
            case 'end_date':
                // Set End selection for reports summary component
                this.setState({allowFetch: false, selectedEndDate: value});
                break;
            case 'offset':
                // Set Time Zone Offset selection for reports summary component
                this.setState({allowFetch: false, selectedOffset: value});
                break;
            default:
                return
        }
    };

    /**
     * Handle submit from DateRangeFilterWithSubmit
     */
    handleDateRangeSubmit = () => {
        this.setState({
            allowFetch: true,
            dataState: 'fetching'
        }, () => {
            this.setState({
                allowFetch: false
            })
        });
    };

    handleSummaryComplete = () => {
        this.setState({
            dataState: 'complete'
        });
    };

    render() {
        const {
            allowFetch,
            dataState,
            selectedEndDate,
            selectedOffset,
            selectedStartDate,
            system
        } = this.state;

        if (!isSysopOrSysadmin()) {
            if (!hasSectionAccess('vip_signups')) return <NoAccess/>;
        }

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>VIP Signups Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A VIP Signups Report searches for total numbers of Loyalty Signups per Location.</p>
                    <p>Select a Date Range and click Search to generate a Report.</p>
                </span>
            );
        };

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filter (Start Date, End Date, Time Zone) */}
                        <DateRangeFilterWithSubmit
                            onSelectStartDate={this.handleDateRangeFilterSelect}
                            onSelectEndDate={this.handleDateRangeFilterSelect}
                            onSelectOffset={this.handleDateRangeFilterSelect}
                            includeOffset={false}
                            dataState={dataState}
                            onSubmit={this.handleDateRangeSubmit}
                        />

                        {/* Print Header */}
                        {selectedStartDate && selectedEndDate &&
                            <ReportHeaderState
                                reportType="VIP Signups Report Summary"
                            />
                        }

                        {/* VIP Trends Report Content */}
                        {selectedStartDate && selectedEndDate && selectedOffset &&
                            <VIPSignupsReport
                                system={system}
                                startDate={selectedStartDate}
                                endDate={selectedEndDate}
                                offset={selectedOffset}
                                allowFetch={allowFetch}
                                onSummaryComplete={this.handleSummaryComplete}
                            />
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/VIPSignupsReports.js